import REGEX from "../constants/regex";

export const validateField = (field) => {
  const value =
    typeof field.value === "string" ? field.value.trim() : field.value;

  if (field.required && !value) {
    return Promise.resolve(`${field.title} is required`);
  }
  let err = "";
  switch (field.name) {
    // This is the place to add email, phone validations, etc
    case "email": {
      if (!value.match(REGEX.email)) {
        err = "Please enter a valid email";
      }
      break;
    }
    case "name": {
      if (value && !value.match(REGEX.name)) {
        err = "Please enter a valid name";
      }
      break;
    }
    case "phone_number": {
      if (value) {
        const digitCount = (value.match(/\d/g) || []).length;
        if (!value.match(REGEX.phone) || digitCount < 7 || digitCount > 15) {
          err = "Please enter a valid phone number";
        }
      }
      break;
    }
  }
  return Promise.resolve(err);
};

// Returns a promise, passes an object of {field1:error1, field2:error2}
export const validateForm = (fields) => {
  const errors = fields.map((field) => validateField(field));
  return Promise.all(errors).then((errArr) => {
    return errArr.reduce((errs, err, i) => {
      return { ...errs, [fields[i].name]: err };
    }, {});
  });
};

export default {
  field: validateField,
  form: validateForm
};
